<template>
  <div id="app">
    <header-common class="header-common"></header-common>
    <div class="main">
      <div class="row">
        <router-view class="view"/>
      </div>
    </div>
    <footer-common class="footer-common"></footer-common>
  </div>
</template>
<script>
import HeaderCommon from '@/views/layout/HeaderCommon.vue'
import FooterCommon from '@/views/layout/FooterCommon.vue'
export default {
  name: 'App',
  data() {
    return {
    }
  },
  components: {
    HeaderCommon,
    FooterCommon
  },
  created () {
    
  },
  methods: {

  }
}
</script>
<style lang="less">
@import "./assets/css/reset.css";
html,
body,
#app {
  height: 100%;
}
#app {
  font-family: "Microsoft YaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .header-common {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
    width: 100%;
  }
  .footer-common {
    margin-top: -@footerHeight;
  }
  .main {
    min-height: 100%;
    box-sizing: border-box;
    padding-top: @headerHeight;
    padding-bottom: @footerHeight;
    background-color: #f5f5f5;
    & > .row {
      width: 1200px;
      margin: 0 auto;
    }
  }
}
</style>
